// extracted by mini-css-extract-plugin
export var fileUpload = "_f5-1";
export var modalButton = "_f5-0";